import { useTheme } from "@emotion/react";
import { Container, Typography, Button, Box } from "@mui/material";
import { useRouter } from "next/router";
import NextLink from 'next/link';
import { HomeRounded } from "@mui/icons-material";

export default function MessagePage({ id, admin }) {
  const router = useRouter();
  const theme = useTheme()
  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", mt: 10 }}>
      <Box 
        sx={{ 
          border: `2px solid ${theme.palette.primary.main}`, 
          borderRadius: "12px", 
          p: 4, 
          boxShadow: 3,
          backgroundColor: "white"
        }}
      >
        <Box display="flex" justifyContent="center" mb={4}>
          <svg xmlns="http://www.w3.org/2000/svg" height="68px" viewBox="0 -960 960 960" width="68px" fill={ theme.palette.primary.main}>
            <path d="M605-141h60.25v-87.65L775-254q22-5 47-10.5t25-22.68q0-9.82-9-16.82t-29-13q-40-11-62-35.28T727-404q2-22 22-40.5t52-29.5q29-10 44.5-24t15.5-31q0-20-19.5-32t-39.5-4.36q-6 2.18-12.5 3.27Q783-561 776-561q-27 0-47-21.5T709-633q0-27 15-50.5t15-48.5q0-19.13-16-32.06Q707-777 685-777q-28 0-42.5 16T628-710q0 15 2 32t2 33q0 45-19 69.5T561-551q-11.94 0-24.97-3T512-557q-8 0-11.5 2.75T497-546q0 11 13.5 21t26.5 21q25 21 38 44.5t13 45.37q0 28.13-21.5 48.63Q545-345 516.28-345 505-345 493-347.5q-12-2.5-23.64-3.5-29.62-2-45.49 5.44Q408-338.12 408-323q0 14 14.5 24t40.5 14l142 22.24V-141Zm-471 21-54-25 205-444 54 25-205 444Zm411 39v-131l-88-13q-50-7-79-33.5T349-322q0-40 31.5-65.5T460-411q11 0 20.5 1t17.5 2q10 0 15.5-5t5.5-13q-5-11-13.5-22.5T483-472q-19-19-32-37t-13-38q0-30.14 19-49.57T505-616q10 0 22 2t26 3q10 0 14.5-7t4.5-22q1-20-.5-39t-1.5-37.55Q570-775 600-806t84-31q49.16 0 82.08 28T799-739q0 27-12 50t-17 46q0 8 5 13.5t13 5.5q8-1 16-2.5t17-1.5q40.62 0 69.81 28.99Q920-570.02 920-528q0 38-26.5 67T826-420q-14 5-20.5 10.5T799-398q4 8 15.5 16t29.5 14q31 12 47 33t16 47q0 39-35 60.5T789-195l-64 15v99H545ZM130-547q-24-28-37-62.5T80-681q0-83.16 58-141.08Q196-880 281-880q37.88 0 72.44 13.5Q388-853 416-829l-42 42q-20-16-43-24.5t-49-8.5q-59.17 0-100.58 40.54Q140-738.92 140-681q0 25.04 8.5 48.52Q157-609 173-590l-43 43Zm505 143Z"/>
          </svg>
        </Box>
        {/* <Typography variant="h4" gutterBottom>
          Add Content to Your Page
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          There's nothing here yet. Add content and publish when you're ready.
        </Typography>

        {admin && (
          <Box mt={4}>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => router.push(`/admin-beta/site-builder/?page=${btoa(`page-${id}`)}`)}
            >
              Go to Builder
            </Button>
          </Box>
        )} */}
        {admin? (
            <>
                <Typography variant="h4" gutterBottom> Add Content to Your Page</Typography>
                <Typography variant="body1" color="textSecondary" paragraph> There's nothing here yet. Add content and publish when you're ready. </Typography>
                <Box mt={4}>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={() => router.push(`/admin-beta/site-builder/?page=${btoa(`page-${id}`)}`)}
                    >
                        Go to Builder
                    </Button>
                </Box>
            </>
        ):(
            <>
                <Typography variant="h4" gutterBottom>Content Not Found</Typography>
                <Typography variant="body1" color="textSecondary" paragraph>
                    The page you are looking for doesn’t have any content yet.
                    Please contact your administrator to add content to this page, or check back later.
                </Typography>

                <Box mt={4}>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={() => router.push('/')}
                    >
                    Go to Home
                    </Button>
                </Box>
            </>
        )}
      </Box>
    </Container>
  );
}
